import React from 'react';

interface SkeletonListProps {
    count?: number;
}

export const IsLoading: React.FC<SkeletonListProps> = ({ count = 8 }) => {
    return (
        <div className="gap-2 pt-3 h-full flex flex-col">
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className="rounded bg-gradient-to-tr from-hr-slate-950/30 to-hr-slate-830/30 overflow-hidden rounded-xl relative p-3 flex items-center gap-2"
                >
                    <div className="w-9 h-9 rounded-full relative bg-hr-slate-950/30 overflow-hidden">
                        <div className="w-full h-full skeleton-box"></div>
                    </div>
                    <div className="space-y-1 grow">
                        <div className="h-3 w-10 relative rounded bg-hr-slate-950/30 overflow-hidden">
                            <div className="w-full h-full skeleton-box"></div>
                        </div>
                        <div className="h-2 w-5 rounded relative bg-hr-slate-950/30 overflow-hidden">
                            <div className="w-full h-full skeleton-box"></div>
                        </div>
                    </div>
                    <div className="grow">
                        <div className="h-7 w-full relative bg-hr-slate-950/30 rounded overflow-hidden">
                            <div className="w-full h-full skeleton-box"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};


